import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const HomeGuessYouLike = style({
    display: 'block',
    paddingLeft: 15,
    paddingRight: 15
})

export const rowTitle = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    ...csstips.center,
    paddingTop: 14,
    paddingBottom: 14
})

export const GuessContentItemCoverItem = style({
    width: '100%',
    height: '22.93333vw',
    maxHeight: 120,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    overflow: 'hidden'
})

export const ChangeButton = style({
    ...csstips.flexRoot,
    ...csstips.center,
    cursor: 'pointer',
    $nest: {
        '&:active': {
            opacity: 0.7
        }
    }
})

export const ChangeButtonImg = style({
    display: 'inline-block',
    width: 14,
    height: 14,
    marginRight: 5
})

export const titleName = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500
})

export const changeSomeContent = style({
    fontSize: 14,
    color: '#999999',
    lineHeight: '14px'
})

const rotateAnimation = keyframes({
    '0%': { '-webkit-transform': 'rotate(0deg)'},
    '100%': { '-webkit-transform': 'rotate(-450deg)' }
  })

export const RotateTransform = style({
    animationName: rotateAnimation,
    animationDuration: '800ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease',
    animationDirection: 'alternate'
})

export const GuessContent = style({
    ...csstips.flexRoot,
    ...csstips.wrap,
    ...csstips.betweenJustified,
    width: '100%'
})

export const GuessContentItem = style({
    width: '44.53vw',
    maxWidth: '213.7px',
    background: '#FFFFFF',
    marginBottom: 10,
    position: 'relative',
    boxShadow: '0 5px 8px 0 rgba(51,51,51,0.05)',
    borderRadius: 8,
    $nest: {
        // '&::before': {
        //     'content': `" "`,
        //     'border': '1px solid #E1E1E1',
        //     'position': 'absolute',
        //     'width': '200%',
        //     'height': '200%',
        //     'transform': 'scale(0.5, 0.5)',
        //     'transformOrigin': '0 0',
        //     'boxSizing': 'border-box',
        //     'borderRadius': 8,
        //     '-webkitTransform': 'scale(0.5, 0.5)',
        //     '-webkit-transform-origin': '0 0'
        // },
        '&:active': {
            background: '#f8f8f8',
            borderBottomLeftRadius: 6,
            borderBottomRightRadius: 6
        }
    }
})

export const GuessContentItemCover = style({
    position: 'relative',
    overflow: 'hidden'
})

export const GuessContentItemTitle = style({
    position: 'relative',
    fontSize: 16,
    color: '#333333',
    lineHeight: '22px',
    fontWeight: 500,
    padding: '7px 10px 0 10px',
    marginBottom: 7,
    zIndex: 10
})

export const statusLine = style({
    ...csstips.flexRoot,
    position: 'absolute',
    background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))',
    bottom: 0,
    width: '100%',
    paddingLeft: 10,
    height: 50,
    ...csstips.end,
    $nest: {
        '& span': {
            ...csstips.flexRoot,
            ...csstips.center,
            bottom: 5,
            whiteSpace: 'nowrap',
            position: 'relative'
        }
    }
})

export const statusLineTag = style({
    width: 12
})

export const statusLineNum = style({
    color: '#fff',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '12px',
    marginLeft: 5,
    marginRight: 15
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeGuessYouLike/HomeGuessYouLike.style.ts